import styled from "styled-components";
import { ReactComponent as DeleteIcon } from "../../../../assets/images/icons/delete.svg";
import { orderService } from "../../../../service/OrderService";
import colors from "../../../../theme/color/ColorTheme";
import fontSize from "../../../../theme/fonts/FontTheme";

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  background: #fff;
  border-radius: 8px;
  border: 1px solid ${colors.dash};
  border-bottom: none;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
`;
const TableHead = styled.thead`
  background-color: ${colors.backgroundTintSecondary};
`;
const Th = styled.th`
  padding: 16px;
  font-weight: 500;
  font-size: ${fontSize.s};
  color: #727272;
`;
const TableBody = styled.tbody``;

const Td = styled.td`
  padding: 14px 16px;
  font-size: ${fontSize.s};
  border-bottom: 1px solid ${colors.dash};
  vertical-align: middle;

  &:first-child {
    font-weight: 500;
  }
`;

const ActionIcons = styled.div`
  display: flex;
  gap: 12px;
  svg {
    width: 24px;
    height: 24px;
    cursor: pointer;
    transition: fill 0.2s;

    &:hover {
      fill: #0070f3;
    }
  }
`;
const ProductCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 4px;
  }

  span {
    display: block;
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }
`;
const OrderDetailsTable = ({ orderId, orders, setReload }) => {
  const handleDeleteItem = async (itemId) => {
    if (orders.length < 2) {
      alert("Cannot delete. Order needs to have atleast one item");
    } else {
      if (!window.confirm("Are you sure you want to delete this item?")) {
        return;
      }
      orderService.deleteItemFromOrder(
        orderId,
        itemId,
        () => {
          setReload(true);
        },
        {
          default: (message) => {
            alert("Error deleting item : ", message);
          },
        }
      );
    }
  };
  return (
    <TableWrapper>
      <StyledTable>
        <TableHead>
          <tr>
            <Th>Product</Th>
            <Th>Product ID</Th>
            <Th>Price</Th>
            <Th>Quantity</Th>
            <Th>Total</Th>
            <Th>Size</Th>
            <Th>Color</Th>
            <Th>Actions</Th>
          </tr>
        </TableHead>
        <TableBody>
          {orders.map((order) => (
            <tr key={order.id}>
              <Td>
                <ProductCell>
                  <img
                    src={process.env.REACT_APP_IMAGE_BASE_URL + order.thumbnail}
                    alt={order.name}
                  />
                  <span>{order.name}</span>
                </ProductCell>
              </Td>
              <Td>{order._id}</Td>
              <Td>Rs. {order.unitPrice}</Td>
              <Td>{order.quantity}</Td>
              <Td>Rs. {order.totalPrice}</Td>
              <Td>{order.size}</Td>
              <Td>{order.color}</Td>
              <Td>
                <ActionIcons>
                  <DeleteIcon
                    onClick={() => {
                      handleDeleteItem(order._id);
                    }}
                  />
                </ActionIcons>
              </Td>
            </tr>
          ))}
        </TableBody>
      </StyledTable>
    </TableWrapper>
  );
};

export default OrderDetailsTable;
